<i18n
  src="@/locales/views/service_provider/services/container_op/list_schedules.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container_scheduled_service.yml" lang="yaml"></i18n>
<template>
  <div class="flex flex-row justify-between">
    <bread-crumbs :labels="[module_name]"></bread-crumbs>
    <new-button
      @click.prevent="goToNew"
      :label="$t('labels.new_link')"
      class="mt-8 mb-8"
    />
  </div>
  <div class="mt-8 flex flex-col" v-if="render_schedules">
    <div class="table-first-container">
      <div class="table-second-container">
        <div class="table-third-container">
          <table class="table">
            <thead class="table-header">
              <tr>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.container_scheduled_service.scheduled_at") }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.container_scheduled_service.status_id") }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.container_scheduled_service.agro_exporter_id") }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.container_scheduled_service.container_id") }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{
                    $t("model.container_scheduled_service.service_templates")
                  }}
                </th>
                <th scope="col" class="table-header-cell"></th>
              </tr>
            </thead>
            <tbody class="table-body">
              <tr
                class="table-row"
                v-for="container_scheduled_service in container_scheduled_services"
                :key="container_scheduled_service.id"
              >
                <td class="table-cell">
                  {{
                    dateFormatter(
                      container_scheduled_service.scheduled_at,
                      "DD MMM YYYY hh:mm A",
                      "YYYY-MM-DDTHH:mm:ss"
                    )
                  }}
                </td>
                <td class="table-cell-main">
                  <container-scheduled-service-status
                    :status_id="container_scheduled_service.status_id"
                  />
                </td>
                <td class="table-cell">
                  {{ container_scheduled_service.agro_exporter?.name }}
                </td>
                <td class="table-cell">
                  {{ container_scheduled_service.container?.container_code }}
                </td>
                <td class="table-cell">
                  {{
                    container_scheduled_service.service_templates
                      .map((s) => s.name)
                      .join(", ")
                  }}
                </td>
                <td class="table-cell-action">
                  <button
                    class="link"
                    @click="goToShowSchedule(container_scheduled_service)"
                  >
                    <i class="fa-solid fa-pen"></i
                    ><span class="space-icon"></span>
                    {{ $t("labels.manage_link") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <loading-message v-else />
  <div />
</template>

<script>
import Requester from "@/views/service_provider/requesters/services/container_op/list_schedules.js";
import ContainerScheduledServiceStatus from "@/components/views/service_provider/services/container_op/ContainerScheduledServiceStatus.vue";
import BreadCrumbs from "@/components/views/layout/BreadCrumbs.vue";

export default {
  components: { BreadCrumbs, ContainerScheduledServiceStatus },
  props: ["service_provider_id"],
  data() {
    return {
      container_scheduled_services: [],
      render_schedules: false,
    };
  },
  methods: {
    fetchSchedules: async function () {
      let response = await Requester.fetchSchedules({
        service_provider_id: this.service_provider_id
      });
      this.container_scheduled_services = response.data;
      this.render_schedules = true;
    },
    goToNew: function () {
      this.$router.push({
        name: "sp_services_container_op_new_schedule_path",
        params: {
          service_provider_id: this.service_provider_id,
        },
      });
    },
    goToShowSchedule: function (container_scheduled_service) {
      this.$router.push({
        name: "sp_services_container_op_show_schedule_path",
        params: {
          container_scheduled_service_id: container_scheduled_service.id,
          service_provider_id: this.service_provider_id,
        },
      });
    },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          service_provider_id: this.service_provider_id,
        },
      }).then(() => {
        this.fetchSchedules();
      })
    );
  },
};
</script>
